import { FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getCategorySelected } from "../../../../Redux/modules/categories/selectors";
import {
  getLoadOptimals,
  getSimulateOptimals, setFormDataOptimalPrices
} from "../../../../Redux/modules/what-if/optimal-prices/actions";
import { getOptimalPricesFormData } from "../../../../Redux/modules/what-if/optimal-prices/selectors";

const RadioBtnGroup = () => {
  const [t, i18n] = useTranslation("global");
  const dispatch = useDispatch();
  const typeFunctions = ["lineal", "polynomial", "logarithmic"];
  const tempOptimalPrices = useSelector(getOptimalPricesFormData);
  const categorySelected = useSelector(getCategorySelected);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "flex-end",
        alignContent: "start",
      }}
    >
      <FormLabel
        sx={{
          color: (theme) => `${theme.palette.custom.primaryVariant}`,
          fontWeight: "bold",
          "&.Mui-focused fieldset,&.Mui-focused ": {
            color: (theme) => `${theme.palette.custom.primaryVariant}`,
          },
          marginRight: "0.5rem",
        }}
        id="radio-subcategories-group-label"
      >
        {`${t("price_management.curves_component.type_function")}`}
      </FormLabel>
      <RadioGroup
        style={{ display: "flex", flexDirection: "row" }}
        aria-labelledby="radio-function-type-label"
        value={tempOptimalPrices.functionType}
        name="radio-function-type"
        onChange={(e) => {
          dispatch(
            setFormDataOptimalPrices({
              propertyName: "functionType",
              propertyValue: e.target.value,
            })
          );
         dispatch(getLoadOptimals.trigger(categorySelected.id));
         dispatch(getSimulateOptimals.trigger(categorySelected.id));
        }}
      >
        {typeFunctions.map((option, index) => {
          return (
            <FormControlLabel
              key={index}
              value={option}
              control={
                <Radio
                  sx={{
                    "&.Mui-checked": {
                      color: (theme) =>
                        `${theme.palette.custom.primaryVariant}`,
                    },
                  }}
                />
              }
              label={`${t("price_management.curves_component." + option)}`}
              sx={{ marginBottom: "-10px" }}
            />
          );
        })}
      </RadioGroup>
    </div>
  );
};

export default RadioBtnGroup;
